'use client'

import { ErrorBlock } from '@/components/common/ErrorBlock'
import { LoadingMask } from '@/components/common/LoadingMask'
import { Subheader } from '@/components/common/Subheader'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { useIsNavigating } from '@/components/providers/NavigationProvider'
import { usePage } from '@/components/providers/PageProvider'
import { cn } from '@/utils/commonUtil'

import styles from './Charts.module.scss'
import { ChartsHeading } from './ChartsHeading/ChartsHeading'
import { ChartsManaCurve } from './ChartsManaCurve/ChartsManaCurve'
import { ChartsRankOverTime } from './ChartsRankOverTime/ChartsRankOverTime'
import { ChartsTypeDistribution } from './ChartsTypeDistribution/ChartsTypeDistribution'

export const Charts = () => {
  const isNavigating = useIsNavigating()
  const { page } = usePage()

  if (!page?.charts) return <ErrorBlock />

  const { manaCurve, rankOverTime, typeDistribution } = page.charts

  return (
    <div className={styles.container}>
      <Subheader>
        <IconWithLabel iconBefore='chartSimple'>Charts</IconWithLabel>
      </Subheader>
      <div className={styles.content}>
        {typeDistribution && (
          <div className={cn(styles.chartWrap, { styles, variant: 'type' })}>
            <ChartsHeading heading='Average Type Distribution' />
            <ChartsTypeDistribution />
          </div>
        )}
        {manaCurve && (
          <div className={cn(styles.chartWrap, { styles, variant: 'curve' })}>
            <ChartsHeading heading='Average Mana Curve' />
            <ChartsManaCurve />
          </div>
        )}
        {rankOverTime && (
          <div className={cn(styles.chartWrap, { styles, variant: 'timeline' })}>
            <ChartsHeading
              description='Ranked by quantity of new/updated decks per month'
              heading='Popularity History'
            />
            <ChartsRankOverTime />
          </div>
        )}
        <LoadingMask loading={isNavigating} />
      </div>
    </div>
  )
}
